import './App.css';

function App() {
  return (
    <div className="App">
      <main className="container">
        <header className="header">
          <h1>Hi, I'm Chad McGuire 👋</h1>
          <p className="subtitle">Entrepreneur and software engineer.</p>
        </header>

        <section className="content">
          <div className="ventures">
            <h2>Ventures</h2>

            <div className="venture">
              <h3>
                <a href="https://sparrowintel.com/" target="_blank" rel="noopener noreferrer">
                  Sparrow Intel
                  <svg className="external-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <line x1="10" y1="14" x2="21" y2="3"></line>
                  </svg>
                </a>
              </h3>
              <p className="role-label">Cofounder</p>
              <p className="description">AI-powered guest communications and reputation management platform for vacation rental operators</p>
            </div>

            <div className="venture">
              <h3>
                <a href="https://dreamistays.com/" target="_blank" rel="noopener noreferrer">
                  DREAMI STAYS
                  <svg className="external-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <line x1="10" y1="14" x2="21" y2="3"></line>
                  </svg>
                </a>
              </h3>
              <p className="role-label">Founder</p>
              <p className="description">Curated collection of unique short-term and mid-term rental properties</p>
            </div>
          </div>

          <div className="role">
            <h2>Current</h2>
            <p>Software Engineer at Microsoft</p>
          </div>

          <div className="cta">
            <h2>Let's Build Together</h2>
            <p>Need AI agents or intelligent automation for your industry? Let's talk about bringing your vision to life.</p>
            <a href="mailto:chadmcguire@outlook.com" className="email-link">
              <svg className="email-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              Get in touch
            </a>
          </div>
        </section>

        <footer className="footer">
          <a href="https://www.linkedin.com/in/chad-mcguire" target="_blank" rel="noopener noreferrer" className="linkedin-link">
            <svg className="linkedin-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
            Connect on LinkedIn
          </a>
        </footer>
      </main>
    </div>
  );
}

export default App;
